import React from "react";
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from "mobx-react";
import {SideMenuItemsListBox} from "../side-menu-rework/side-menu-items/boxes/side-menu-items-list.box";
import {SideMenuLinksGroup} from "../side-menu-rework/side-menu-links-group/side-menu-links-group.component";
import {GameSearchComponent} from "../game-search/game-search.component";
import {StoreButton} from "./store-button/store-button.component";
import {InsideOrbitMenuContainerComponent} from "../inside-orbit-menu-container/inside-orbit-menu-container.component";
import {isInsideAutomation} from '../../../utils/automation-helpers';
import {MenuLinksGroupsContainerBox} from "./boxes/menu-links-groups-container.box";
import {SideMenuContainerBox} from "./boxes/side-menu-container.box";
import {CyClass} from '../../../common/cy-classes';
import {MobileHelpCenterMenuItemComponent} from "./mobile-help-menu-item/mobile-help-center-menu-item.component";
import {
  MobileLangSwitcherMenuItemComponent
} from "./mobile-lang-switcher-menu-item/mobile-lang-switcher-menu-item.component";
import {SideMenuHorizontalLineBox} from "./horizontal-ruler/side-menu-horizontal-line.box";
import {MobileMenuItemsContainerBox} from "./boxes/mobile-menu-items-container.box";
import {
  MobileStateSelectorMenuItemComponent
} from "./mobile-state-selector-menu-item/mobile-state-selector-menu-item.component";
import {RelatedSitesComponent} from "../main-nav/boxes/related-sites/related-sites.component";
import {MenuItemKey} from "../../services/configurations/config-data-sections/generated-config-const";


export const SideMenu = observer(class SideMenu extends OrbitComponent {

  render() {
    const linkBlocks = this.services.configuration.data.sideMenu.menuLinksBlockOrder;

    return (
      <SideMenuContainerBox className="cy-side-menu">
        {this.services.device.isMobile ? <GameSearchComponent className={CyClass('cy-menu-links-group')} /> : null}

        <MenuLinksGroupsContainerBox>
          {linkBlocks.map(keys => this._renderSideMenuSection(...keys))}

          {this._renderMobileMenuElements()}
        </MenuLinksGroupsContainerBox>
      </SideMenuContainerBox>
    );
  }

  /* Renders the QA button container for mobile only.Can't put it in header on mobile since it overlaps with 888logo on portrait mode */
  private _renderInsideOrbitMenuContainerMobile(): React.ReactNode {
    if (!this.services.device.isMobile) {
      return null;
    }
    if (isInsideAutomation()) {
      return null;
    }
    return <InsideOrbitMenuContainerComponent />

  }

  private _renderSideMenuSection(...keys: MenuItemKey[]): React.ReactNode {

    if (this.services.device.isMobile && this.services.gameSearch.isSearchBoxOpened) {
      return null;
    }

    return <SideMenuLinksGroup key={keys.join(',')} menuItemKeys={keys} />
  }

  private _renderMobileMenuElements(): React.ReactNode {
    if (!this.services.device.isMobile || this.services.gameSearch.isSearchBoxOpened) {
      return null;
    }

    return (
      <MobileMenuItemsContainerBox className="cy-menu-links-group" >
        {this._renderBottomMenuSection()}
        {this._renderRelatedSitesLinks()}
        {this._renderInsideOrbitMenuContainerMobile()}
        {this._renderStoreButton()}
      </MobileMenuItemsContainerBox>
    );
  }

  private _renderMobileStateSelector = () => {
    if (!this.services.stateOfResidenceIdentifier.shouldDisplayStateSelectorButton()) {
      return null;
    }
    return <MobileStateSelectorMenuItemComponent />;
  }

  private _renderBottomMenuSection(): React.ReactNode {
    // Section which contains: language switcher, help menu, state selector.
    const shouldDisplayHelpLink = this.services.configuration.data.sideMenu?.helpLinkMobile?.display;
    const shouldDisplayLanguageSwitcher = !this.services.language.languageSwitcher.isEmpty;
    const shouldDisplayStateSelector = this.services.stateOfResidenceIdentifier.isOneSiteEnabled();

    if (!shouldDisplayHelpLink && !shouldDisplayLanguageSwitcher && !shouldDisplayStateSelector) {
      return null;
    }

    return (
      <SideMenuItemsListBox>
        {this._renderMobileHelp()}
        {this._renderMobileLangSwitcher()}
        {this._renderMobileStateSelector()}
      </SideMenuItemsListBox>
    )
  }


  private _renderMobileHelp(): React.ReactElement {
    if (this.services.configuration.data.sideMenu.helpLinkMobile?.display) {
      return (
        <MobileHelpCenterMenuItemComponent />
      );
    }
    return null;
  }

  private _renderMobileLangSwitcher(): React.ReactNode {
    if (this.services.language.languageSwitcher.isEmpty) {
      return null;
    }
    return (
      <MobileLangSwitcherMenuItemComponent />
    );
  }

  private _renderRelatedSitesLinks() {
    if (this.services.mediaQuery.lAndAbove) {
      return null;
    }

    return (
        <RelatedSitesComponent/>
    );
  }

  private _renderStoreButton(): React.ReactNode {
    if (!this.services.configuration.data.sideMenu.store_button.display) {
      return null;
    }

    return (
      <React.Fragment>
        <SideMenuHorizontalLineBox />
        <StoreButton />
      </React.Fragment>
    );
  }
});
